import type { HTMLAttributes, ReactNode } from 'react';

export interface SearchOptionData {
  title: ReactNode;
  image: string;
  subtitle?: ReactNode;
}

export interface SearchOptionProps
  extends SearchOptionData,
    Omit<HTMLAttributes<HTMLDivElement>, 'title'> {}
